import { Opcao } from './opcao';

export class PlanoCurso {
  id: number;
  nome: string;
  nomeCurso: string;
}
